module.exports = __webpack_public_path__ + "img/RedClear.62c15d67.jpg";